import React from 'react';
import { LayoutDashboard, Briefcase, PieChart, LineChart, Settings, Lock } from 'lucide-react';
import { useUserTier } from '../../hooks/useUserTier';
import { useUpgradeModal } from '../../contexts/UpgradeModalContext';

const NAV_ITEMS = [
  { value: 'dashboard', icon: LayoutDashboard, label: 'Home' },
  { value: 'investments', icon: Briefcase, label: 'Invest' },
  { value: 'allocation', icon: PieChart, label: 'Allocate', locked: 'Asset Allocation' },
  { value: 'performance', icon: LineChart, label: 'Perform', locked: 'Portfolio Performance' },
  { value: 'settings', icon: Settings, label: 'Settings' },
];

const DashboardMobileNav = ({ activeTab, setActiveTab }) => {
  const { isGatewayContinuity } = useUserTier();
  const { openUpgradeModal } = useUpgradeModal();

  const handleClick = (item) => {
    if (isGatewayContinuity && item.locked) {
      openUpgradeModal(item.locked);
      return;
    }
    setActiveTab(item.value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xs border-t border-slate-200 z-50 sm:hidden" data-testid="mobile-bottom-nav">
        <div className="grid grid-cols-5 h-14">
          {NAV_ITEMS.map((item) => {
            const { value, icon: Icon, label, locked } = item;
            const showLock = isGatewayContinuity && !!locked;
            return (
              <button
                key={value}
                data-testid={showLock ? `mobile-nav-${value}-locked` : `mobile-nav-${value}`}
                onClick={() => handleClick(item)}
                className={`flex flex-col items-center justify-center gap-0.5 tap-bounce relative ${
                  activeTab === value ? 'text-emerald-600' : 'text-slate-400'
                } ${showLock ? 'opacity-70' : ''}`}
              >
                <Icon
                  className={`w-5 h-5 transition-transform duration-200 ease-out ${activeTab === value ? 'scale-110' : 'scale-100'}`}
                  strokeWidth={activeTab === value ? 2.5 : 1.5}
                />
                <span className={`text-[10px] font-medium leading-none transition-all duration-200 ${
                  activeTab === value ? 'opacity-100' : 'opacity-70'
                }`}>{label}</span>
                {showLock && (
                  <Lock className="absolute top-1 right-2 w-2.5 h-2.5 text-slate-500" aria-label="Locked" />
                )}
                {activeTab === value && !showLock && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-emerald-500 rounded-full nav-indicator-enter" />
                )}
              </button>
            );
          })}
        </div>
      </nav>
      <div className="h-14 sm:hidden" />
    </>
  );
};

export default DashboardMobileNav;
